//---- components ---------
import AppPageNotFound from './components/shared/errors/page-not-found.vue';
import InstanceErrorPage from './components/shared/errors/InstanceErrorPage.vue';
import Login from './components/shared/Login.vue';
//---- mixins -------------
//---- services -----------
import logger from './services/app-logger.js'
import ProjectHomeService from './services/projectHome.service.js'
//---- other --------------
import store from './store/index.js';
//---- 3rd-parties --------
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

// Note on performance
// -------------------
// To lazy load the application, we separate it in different chunks and we try
// to reduce what gets loaded with the login page to a minimum in order to have
// a snappy first response time. 
//
// Then we create chunks for different area of the application:
//
//    app-main: is the chunk containing search, results and solution view 
//              components. This chunk is required by any user so it is 
//              prefetched when the login screen is displayed. The content 
//              should be downloaded while the browser is idle, after the 
//              login page was loaded.
//
//    app-ds:   is the chunk containing service session module. This is not
//              used by all customers, so we do not prefetch it.
//
//    app-pwd:  the password recovery page. Not often used, we do not prefetch.
//
//    app-extra: my preferences, about, licenses. These are not often used so
//               we do not prefetch them.
//
//    app-admin: the admin section with KPI dashboard, admin tools, info page.
//               this is only accessible to a few users, so we do not prefetch.
//
//    app-authoring: the functionality available to authors: authoring page, 
//                   drafts, solution comparison, versions. We do not preload
//                   as end users don't have access to it.
//
//    app-solo:  the solo (KMOffline) download page. This is not used by many 
//               users, do not preload.
//
const userRoutes = [
  {
    path: '/home',
    name: 'home',
    meta: {
      title: 'Service Knowledge and Diagnostics',
    },
    component: () => import( /* webpackChunkName: "app-main", webpackPrefetch: true */ './components/callcenter/layouts/HomeRedirect.vue'),
  },
  {
    path: '/project-selection',
    name: 'project-selection',
    meta: {
      title: 'Service Knowledge and Diagnostics',
    },
    component: () => import( /* webpackChunkName: "app-main", webpackPrefetch: true */ './components/shared/ProjectSelection.vue'),
  },
  {
    path: '/project-home',
    name: 'project-home',
    meta: {
      title: 'Service Knowledge and Diagnostics',
    },
    // redirect: () => {
    //   return {name: "/mobile-search"}
    // }
    component: () => import(/* webpackChunkName: "app-main", webpackPrefetch: true */ './components/callcenter/layouts/ProjectHome.vue'),
  },
  {
    path: '/fieldServiceSearch',
    name: 'fieldServiceSearch',
    meta: {
      title: 'Service Knowledge and Diagnostics',
    },
    redirect: () => {
      return { name: "project-home" }
    }
  },
  // {
  //   path: '/mobile-search',
  //   name: 'mobile-search',
  //   meta: {
  //     title: 'Service Knowledge and Diagnostics',
  //   },
  //   component: () => import(/* webpackChunkName: "app-main", webpackPrefetch: true */ './components/callcenter/layouts/MobileSearchLayout.vue'),
  // },
  {
    path: '/password-recovery',
    name: 'password-recovery',
    meta: {
      title: 'Service Knowledge and Diagnostics',
      public: true,
      onlyWhenLoggedOut: true,
    },
    component: () => import(/* webpackChunkName: "app-pwd" */ './components/shared/PasswordRecovery.vue'),
  },
  {
    path: '/advisor-application-error',
    name: 'advisor-application-error',
    meta: {
      title: 'Service Knowledge and Diagnostics',
      public: true,
      onlyWhenLoggedOut: true,
    },
    component: () => import(/* webpackChunkName: "app-pwd" */ './components/shared/AdvisorApplicationError.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: 'Service Knowledge and Diagnostics',
      public: true,
      onlyWhenLoggedOut: true,
    },
  },
  {
    path: '/logout',
    name: 'logout',
    component: Login,
  },
  {
    path: '/my-preferences',
    name: 'my-preferences',
    component: () => import(/* webpackChunkName: "app-extra" */ './components/callcenter/tools/MyPreference.vue'),
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import(/* webpackChunkName: "app-admin" */ './components/callcenter/tools/Admin.vue'),
  },
  {
    path: '/colors',
    name: 'colors',
    component: () => import(/* webpackChunkName: "app-admin" */ './components/callcenter/tools/Colors.vue'),
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "app-extra" */ './components/shared/admin/About.vue'),

  },
  {
    path: '/licenses',
    name: 'licenses',
    component: () => import(/* webpackChunkName: "app-extra" */ './components/shared/admin/Licenses.vue'),

  },
  {
    path: '/ds',
    name: 'ds',
    component: () =>
      import(/* webpackChunkName: "app-ds" */ './components/callcenter/service-sessions/DSTemplate.vue'),
    children: [
      {
        path: 'dashboard',
        component: () =>
          import(/* webpackChunkName: "app-ds" */
            './components/callcenter/service-sessions/ds-dashboard/DSDashboard.vue'
          ),
      },
      {
        path: 'details',
        component: () =>
          import(/* webpackChunkName: "app-ds" */
            './components/callcenter/service-sessions/ds-detail/DSDetails.vue'
          ),
      },
      {
        path: 'repair-history',
        component: () =>
          import(/* webpackChunkName: "app-ds" */
            './components/callcenter/service-sessions/DSRepairHistory.vue'
          ),
      },
    ],
  },
  // {
  //   path: '/solutionView',
  //   name: 'solutionView',
  //   component: () => import('./components/callcenter/case-details/SolutionView.vue')
  // },
  {
    path: '/tools',
    name: 'tools',
    component: () => import('./components/shared/tools/Tools.vue'),
    redirect: {/* webpackChunkName: "app-admin" */
      name: 'route.details',
    },

    children: [
      {
        path: 'loggers',
        component: () =>
          import(/* webpackChunkName: "app-admin" */ './components/shared/tools/loggers/Loggers.vue'),
      },
      {
        path: 'home',
        component: () => import(/* webpackChunkName: "app-admin" */ './components/shared/tools/Home.vue'),
        name: 'route.details',
      },
      {
        path: 'threadDump',
        component: () =>
          import(/* webpackChunkName: "app-admin" */ './components/shared/tools/threaddump/ThreadDump.vue'),
      },
      {
        path: 'monitoring',
        component: () =>
          import(/* webpackChunkName: "app-admin" */ './components/shared/tools/Monitoring/Monitoring.vue'),
      },
      {
        path: 'indexStatus',
        component: () =>
          import(/* webpackChunkName: "app-admin" */ './components/shared/tools/IndexStatus/IndexStatus.vue'),
      },
      {
        path: 'convertDsBookmark',
        component: () =>
          import(/* webpackChunkName: "app-admin" */
            './components/shared/tools/ConvertDsBookmark/ConvertDsBookmark.vue'
          ),
      },
      {
        path: 'dsTools',
        component: () =>
          import(/* webpackChunkName: "app-admin" */
            './components/shared/tools/DsTools.vue'
          ),
      },
    ],
  },
  {
    path: '/case-details',
    name: 'case-details',
    component: () =>
      import(/* webpackChunkName: "app-main" */ './components/callcenter/case-details/CaseDetails.vue'),
  },
  {
    path: '/solution-modify',
    name: 'solution-modify',
    component: () =>
      import(/* webpackChunkName: "app-authoring" */ './components/callcenter/authoring/SolutionModify.vue'),
  },
  {
    path: '/create-solution',
    name: 'create-solution',
    component: () =>
      import(/* webpackChunkName: "app-authoring" */ './components/callcenter/authoring/SolutionModify.vue'),
  },
  {
    path: '/solution-translate',
    name: 'solution-translate',
    component: () =>
      import(/* webpackChunkName: "app-authoring" */ './components/callcenter/authoring/SolutionModify.vue'),
  },

  {
    path: '/solution-modify-mcm',
    name: 'solution-modify-mcm',
    component: () =>
      import(/* webpackChunkName: "app-authoring" */ './components/callcenter/authoring/SolutionModifyMCM.vue'),
  },

  {
    path: '/solution-version',
    name: 'solution-version',
    meta: {
      alwaysExpanded: true,
    },
    component: () =>
      import(/* webpackChunkName: "app-authoring" */ './components/callcenter/versions/SolutionVersions.vue'),
  },

  {
    path: '/solution-compare',
    name: 'solution-compare',
    component: () => import(/* webpackChunkName: "app-authoring" */ './components/callcenter/authoring/SolutionCompare.vue')
  },

  {
    path: '/solution-preview',
    name: 'solution-preview',
    component: () =>
      import(/* webpackChunkName: "app-main", webpackPrefetch: true */ './components/callcenter/authoring/SolutionPreview.vue'),
  },

  {
    path: '/draft-comparison',
    name: 'draft-comparison',
    component: () =>
      import(/* webpackChunkName: "app-authoring" */ './components/callcenter/draft/DraftComparison.vue'),
  },

  {
    path: '/showcase',
    name: 'showcase',
    meta: {
      public: true,
    },
    component: () => import(/* webpackChunkName: "app-main", webpackPrefetch: true */ './components/callcenter/case-details/ShowCaseRedirect.vue'),
  },

  {
    path: '/bookmarkRedirect',
    name: 'bookmark',
    component: () => import(/* webpackChunkName: "app-main", webpackPrefetch: true */ './components/callcenter/app-header/BookmarkRedirect.vue'),
    meta: {
      public: true,
    },
  },

  {
    path: '/kmofflineDownload',
    name: 'kmofflineDownload',
    component: () => import(/* webpackChunkName: "app-solo" */ './components/callcenter/kmoffline/KMOfflineDownload.vue'),
  },

  {
    path: '/kmofflineSync',
    name: 'kmofflineSync',
    component: () => import(/* webpackChunkName: "app-solo" */ './components/callcenter/kmoffline/KMOfflineSync.vue'),
  },

  {
    path: '/kmofflineStatus',
    name: 'kmofflineStatus',
    component: () => import(/* webpackChunkName: "app-solo" */ './components/callcenter/kmoffline/KMOfflineStatus.vue'),
  },

  {
    path: '/kmofflineRegister',
    name: 'kmofflineRegister',
    component: () => import(/* webpackChunkName: "app-solo" */ './components/callcenter/kmoffline/KMOfflineRegister.vue'),
  },

];

const appRoutes = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/error',
    name: 'instance-error',
    component: InstanceErrorPage,
  },
  {
    path: '*',
    name: 'page-not-found',
    component: AppPageNotFound,
  },
];

const routes = [...userRoutes, ...appRoutes];

export const router = new Router({
  mode: 'history',
  base: '/advisor/',
  routes,
  scrollBehavior(/* to, from, savedPosition */) {
    return { x: 0, y: 0 } // scroll to top on each route change
  }
});

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export default router;

const debugEnabled = false;

function debug(message) {
  if (!debugEnabled)
    return;
  console.log(message);
}
// function trace(message) {
//   if (!debugEnabled)
//     return;
//   console.trace(message);
// }

//
// Method that implements navigation guard for the application. It is used 
// among other things to make sure the user is authenticated when accessing 
// private parts of the application. 
//
router.beforeEach(async (to, from, next) => {
  try {
    router.to = to;
    const isPublic = to.matched.some((record) => record.meta.public);
    const onlyWhenLoggedOut = to.matched.some(
      (record) => record.meta.onlyWhenLoggedOut
    );

    if (debugEnabled) {
      var message = "(0) -- entering router.beforeEach " + from.fullPath + " -> " + to.fullPath;

      var opts = [];
      if (isPublic)
        opts.push("isPublic");
      if (onlyWhenLoggedOut)
        opts.push("onlyWhenLoggedOut");
      if (isPublic || onlyWhenLoggedOut)
        message += " (" + opts.join(", ") + ")";

      debug(message)
    }

    // in case of application error (wrong db version for example, we need to make sure we return to the logout state)
    if (to?.name === 'logout' || to?.name === 'advisor-application-error') {
      // window.localStorage.clear();
      window.sessionStorage.clear();
      store.dispatch("onLogout");
      store.dispatch("auth/logout")
      // return next('/login')
    }

    // set the document title if needed
    if (to?.meta?.title)
      document.title = to.meta.title;

    // if page-not-found or advisor-application-error, nothing else to do 
    if (to?.name === 'page-not-found' || to?.name === 'advisor-application-error') {
      debug("(1) --> next()")
      return next();
    }

    let loggedIn = store.getters["auth/loggedIn"];
    // do we don't know whether the user is logged in or not, the page is being loaded for the first time
    let isSoloUnknown = !store.getters["kmOffline/isKMOfflineKnown"];
    let firstLoad = !store.getters["auth/isLoginStatusKnown"];

    if (!firstLoad && isSoloUnknown) {
        await sleep(10000);
        console.log("isSoloUnknown and it's not the first load. This should not occur... Trying again...")
        isSoloUnknown = !store.getters["kmOffline/isKMOfflineKnown"];
        firstLoad = !store.getters["auth/isLoginStatusKnown"];
    }

    if (!firstLoad && isSoloUnknown) {
      console.log("isSoloUnknown and it's not the first load. This failed even after retry.")
    }


    if (firstLoad || isSoloUnknown) {
      // 1- We could be accessing the page for the first time and we're not logged in
      //      need to send to login
      // 2- We could be returning from authentication, 
      //      need to post to login.action

      // first post to login.action, if not loggedin, return to /login page
      let response = null;
      try {
        response = await store.dispatch("auth/checkLogin");
        loggedIn = true;
        debug("loggedIn = true ")

        // if there's a nextPage, that means we just logged in, we need to go to the 
        // next page returned by the server. Otherwise we just continue processing
        if (response?.nextPage) {
          let skipNextPage = false;
          for (var propName in to.query) {
            if (Object.prototype.hasOwnProperty.call(to.query, propName) && propName == 'skd.login') {
              skipNextPage = to.query[propName]
            }
          }
          skipNextPage |= to.name.endsWith("showcase") || to.name.endsWith("bookmark")
          if (skipNextPage) {
            debug("(2) --> skipNextPage")
          } else {
            debug("(2) --> next(/" + response.nextPage + ")")
            return next("/" + response.nextPage);
          }
        }
      }
      catch (error) {
        debug("auth/checkLogin threw an error " + JSON.stringify(error, null, 2))
        // loggedIn = !!error.authenticated;
        loggedIn = store.getters["auth/loggedIn"];
        // not logged in, continue processing
        if(error?.kmOffline == 'not-initialized' && ( to?.name !== 'login' && to?.name !== 'kmofflineSync' )) {
          store.dispatch("hideGlobalLoadingOverlay", "login page displayed");
          debug("km-offline not initialized when going to " + to?.name)
          debug("(3) --> next(/login)")
          return next('/login');
        }
        // errors are normal, don't log them 
        // else
        //    console.error("Error in checkLogin", error)
      }
    }

    if (debugEnabled) {
      debug({
        isSoloUnknownBefore: isSoloUnknown,
        isSoloUnknownAfter: !store.getters["kmOffline/isKMOfflineKnown"],
        firstLoad: firstLoad,
        isPublic: isPublic,
        loggedIn: loggedIn
      })
    }

    if (!isPublic && !loggedIn || to.query["force_new_session"]) {
      debug("(4) --> handleLogin(to, next)");
      return handleLogin(to, next);
    }


    // Do not allow user to visit login page or register page if they are logged in
    if (loggedIn && onlyWhenLoggedOut) {

      const showProjectSelectionPage = store.getters['header/showProjectSelectionPage'];
      if (showProjectSelectionPage) {
        store.dispatch("projectData/clear");
        debug("(5) --> next('/project-selection'))");
        return next('/project-selection');
      }
      else if (!store.getters["kmOffline/status"]?.isInitialized) {
        debug("(5a) --> next('/kmofflineSync'))");
        return next('/kmofflineSync');
      }
      else {
        await ProjectHomeService.resetProject()
        debug("(6) --> next('/home'))")        
        return next('/home');
      }
    }

    if (from.name == 'login') {
      const stateRelayUrl = store.getters['auth/relayState'];
      if (stateRelayUrl && to.fullPath !== stateRelayUrl) {
        store.dispatch('auth/setRelayState', '')
        debug("(7) --> next(" + stateRelayUrl + ")");
        return next(stateRelayUrl)
      }
    }

    debug("(8) --> next()")
    return next();

  } catch (e) {
    e.details = "(to: " + to.fullPath + ", from: " + from.fullPath + ")"
    logger.logClientSideErrorToServer(e)
    debug("(9) --> error()")

  }
  debug("(10) --> fallthrough()")

}); // end router.beforeEach  


async function handleLogin(to, next) {
  try {
    const response = await store.dispatch("auth/login", {});
    if (response.nextPage)
      return next("/" + response.nextPage);
  }
  catch {
    // should we report the error here? probably not
  }
  store.dispatch("hideGlobalLoadingOverlay", "login page displayed");
  return next('/login');
}

router.afterEach(() => {router.to = null})